module.exports = __webpack_public_path__ + "img/counseling2.a039cf9d.png";